import { Grid, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Edit } from '@material-ui/icons';
import { getInfosDashboard } from '@webapps/business';
import { Modal, useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../theme';
import GoodToKnowEdit from './EditContent/GoodToKnowEdit';

const {
  colors: { background, subTextColor },
} = theme;

const GoodToKnow = ({ goodtoknow }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [goodToKnowEdit, setGoodToKnowEdit] = useState(false);

  const handleOpenGoodToKnowEdit = () => {
    setGoodToKnowEdit(true);
  };
  const handleCloseGoodToKnowEdit = () => {
    setGoodToKnowEdit(false);
  };

  return (
    <Grid container direction="column" className={classes.mainContainer} xs>
      <Grid item className={global.title} xs>
        <FormattedMessage id="business.vitrine.goodtoknow" />
      </Grid>
      <Grid item style={{marginTop: spacing(1)}} className={global.subTitle} xs>
        <FormattedMessage id="business.vitrine.goodtoknowSub" />
      </Grid>
      <Grid item>
        <GoodToKnowEdit
          close={handleCloseGoodToKnowEdit}
          goodtoknow={goodtoknow}
        />
      </Grid>
    </Grid>
  );
};

const styles = ({ spacing, fontSizes }) => ({
  mainContainer: {
    marginTop: 20,
    padding: '20px',
    background,
    borderRadius: 10,
  },
});

GoodToKnow.propTypes = {
  goodtoknow: PropTypes.string,
};

export default GoodToKnow;
